export interface Analytics {
  track: (name: string) => void
}

export class AnalyticsImpl implements Analytics {
  track(name: string) {
    pendo.track(name)
  }
}
